import { render, staticRenderFns } from "./testPage.vue?vue&type=template&id=b57106ec&scoped=true&"
import script from "./testPage.vue?vue&type=script&lang=js&"
export * from "./testPage.vue?vue&type=script&lang=js&"
import style0 from "./testPage.vue?vue&type=style&index=0&id=b57106ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57106ec",
  null
  
)

export default component.exports